import { connect } from "react-redux";
import get from "lodash/get";

import { getChartSensors as onGetChartSensors } from "../../actions/chartSensorsActions";

const mapStateToProps = (state) => ({
  chartSensorsDataState: state.chartSensors.dataState,
  chartSensorsData: get(state, ["chartSensors", "data"], null),
  chartSensorsErrors: get(state, ["chartSensors", "errors"], []),
});

const mapDispatchToProps = {
  onGetChartSensors,
};

const withChartSensors = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withChartSensors };
